import { useSyncExternalStore } from 'react';

/**
 * The Asoebi Orders list's bar choices: the Archived switch and the two
 * Filters-popover groups. A tiny external store (same shape as
 * useProcurementBar), so the bar and the list never need props between them
 * and the choices survive moving to an order and back.
 */
export interface AsoebiOrdersBarState {
  archived: boolean;
  /** '' = every status. */
  status: string;
  /** '' = every payment state. */
  payment: string;
}

const INITIAL: AsoebiOrdersBarState = { archived: false, status: '', payment: '' };

let state: AsoebiOrdersBarState = INITIAL;
const listeners = new Set<() => void>();

export const getAsoebiOrdersBar = (): AsoebiOrdersBarState => state;

/** A patch that changes nothing is dropped, so publishing from an effect can never loop. */
export function setAsoebiOrdersBar(patch: Partial<AsoebiOrdersBarState>): void {
  const changed = (Object.keys(patch) as Array<keyof AsoebiOrdersBarState>).some(k => patch[k] !== state[k]);
  if (!changed) return;
  state = { ...state, ...patch };
  listeners.forEach(l => l());
}

export function resetAsoebiOrdersBar(): void {
  state = INITIAL;
  listeners.forEach(l => l());
}

const subscribe = (listener: () => void): (() => void) => {
  listeners.add(listener);
  return () => { listeners.delete(listener); };
};

export function useAsoebiOrdersBar(): AsoebiOrdersBarState {
  return useSyncExternalStore(subscribe, getAsoebiOrdersBar, getAsoebiOrdersBar);
}
